import { render, staticRenderFns } from "./partner-api-form-data.vue?vue&type=template&id=fbb43a9e&scoped=true&"
import script from "./partner-api-form-data.ts?vue&type=script&lang=ts&"
export * from "./partner-api-form-data.ts?vue&type=script&lang=ts&"
import style0 from "./partner-api-form-data.scss?vue&type=style&index=0&id=fbb43a9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb43a9e",
  null
  
)

export default component.exports